import { useLayoutEffect as useLayoutEffect } from 'react';
import {
  invokechk3lkgbyxfd as invoke,
  invoke1ef51ay3uv4ui as invoke_0,
} from './raw/EffectHook.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function useLayoutEffectOnce(effect) {
  var tmp = useLayoutEffect;
  // Inline function 'kotlin.emptyArray' call
  var tmp$ret$0 = [];
  invoke(tmp, effect, tmp$ret$0);
}
function useLayoutEffect_0(effect) {
  invoke_0(useLayoutEffect, effect);
}
//region block: exports
export {
  useLayoutEffectOnce as useLayoutEffectOnceb9lqnv5omcti,
  useLayoutEffect_0 as useLayoutEffect2b637pektybx4,
};
//endregion

//# sourceMappingURL=useLayoutEffect.mjs.map
